import { render, staticRenderFns } from "./Bills.vue?vue&type=template&id=1bc50d2a&scoped=true&"
import script from "./Bills.vue?vue&type=script&lang=ts&"
export * from "./Bills.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc50d2a",
  null
  
)

export default component.exports